import { faCheckCircle, faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { PreparationLineWithProduct } from '../../hooks';
import type { LinePick } from '../../models/PreparationModels';
import { LinePickCompletedCard } from './LinePickCompletedCard';

interface CompletedProductsModalProps {
  isOpen: boolean;
  onClose: () => void;
  linePicks: LinePick[];
  /** Líneas de la preparación para resolver producto por `stock_location_order_line_id` */
  lines: PreparationLineWithProduct[];
}

export const CompletedProductsModal: React.FC<CompletedProductsModalProps> = ({
  isOpen,
  onClose,
  linePicks,
  lines,
}) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={onClose} />

      {/* Modal flotante desde abajo */}
      <div
        className={`
        fixed bottom-0 left-0 right-0 z-50 lg:hidden
        bg-background border-t border-border rounded-t-xl
        transform transition-transform duration-300 ease-out
        ${isOpen ? 'translate-y-0' : 'translate-y-full'}
        max-h-[80vh] flex flex-col
      `}
      >
        {/* Header del modal */}
        <div className="flex items-center justify-between p-4 border-b border-border flex-shrink-0">
          <div className="flex items-center space-x-2 text-green-600 dark:text-green-400">
            <FontAwesomeIcon icon={faCheckCircle} className="w-5 h-5" />
            <h3 className="text-lg font-semibold">Productos completados</h3>
            <span className="text-sm text-muted-foreground">({linePicks.length})</span>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-muted rounded-lg transition-colors">
            <FontAwesomeIcon icon={faTimes} className="w-4 h-4 text-muted-foreground" />
          </button>
        </div>

        {/* Contenido scrolleable */}
        <div className="flex-1 overflow-y-auto p-4">
          {linePicks.length === 0 ? (
            <div className="text-center py-8">
              <p className="text-muted-foreground">Aún no hay picks registrados</p>
            </div>
          ) : (
            <div className="space-y-3">
              {linePicks.map((pick) => {
                const pline = lines.find((l) => l.id === pick.stock_location_order_line_id);
                return (
                  <div key={pick.id} className="bg-background border border-border rounded-lg p-3">
                    <LinePickCompletedCard pick={pick} line={pline} />
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Indicador de arrastre (opcional) */}
        <div className="flex justify-center py-2 flex-shrink-0">
          <div className="w-8 h-1 bg-muted-foreground/30 rounded-full" />
        </div>
      </div>
    </>
  );
};
